import React, { unstable_Profiler as ReactProfiler } from 'react'
import PropTypes from 'prop-types'

const logProfile = (id, phase, actualTime, baseTime, startTime, commitTime) => {
  console.group(`${id}'s ${phase} phase:`)
  console.log(`Actual time: ${actualTime}`)
  console.log(`Base time: ${baseTime}`)
  console.log(`Start time: ${startTime}`)
  console.log(`Commit time: ${commitTime}`)
  console.groupEnd()
}

class Profiler extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    onRender: PropTypes.func
  }

  static defaultProps = {
    onRender: logProfile
  }

  render () {
    const { id, onRender, children } = this.props

    return (
      <ReactProfiler id={id} onRender={onRender}>
        {children}
      </ReactProfiler>
    )
  }
}

export default Profiler
